// extracted by mini-css-extract-plugin
module.exports = {"NavigationItem":"Navigationitem_NavigationItem__1Me-C","active":"Navigationitem_active__1tAyA"};